import ReactDOM from 'react-dom/client';
import { InstantSearch,  Configure } from 'react-instantsearch';
import { liteClient as algoliasearch } from 'algoliasearch/lite';
import SearchBox from "../searchbox"
import React, { Component, useState, useEffect } from 'react';
import Reset from "./reset"
import Results from "./results"
// import { breakpoints } from "../../utils"
import { animate } from 'animejs';

const credentials = ALGOLIA_CREDENTIALS || null
const searchClient = algoliasearch(credentials.appId, credentials.apiKey);

    const Typeahead = function(props) {
          const [isActive, setActive] = useState(false);
          const [prevPosition, setPrevPosition] = useState(0);
          const heroElement = document.querySelector(".js-hero")
          const TOP = heroElement
              ? heroElement.getBoundingClientRect().height - 140
              : 710
          useEffect(() => {
           const heroElement = document.querySelector(".js-hero")
          const TOP = heroElement
              ? heroElement.getBoundingClientRect().height - 140
              : 710
          }, []); // runs once after mount
          const keyUp = (event) => {
            		const key = event.which || event.keyCode

                if (key === 27) { // escape key
                  deactivate()
                } else if (!isActive) {
                  activate()
                }
          };

          const activate = (   ) => {
            		setActive(true)
		            animateIn()
          };
          const deactivate = (   ) => {
            		setActive(false)
		            animateOut()
          };

        const animateIn = () =>
              animate(document.scrollingElement, {
            scrollTop: TOP,
            begin: () => {
              setPrevPosition(document.scrollingElement.scrollTop)
            },
            complete: () => {
              document.body.classList.add("is-locked")
            },
            easing: "easeOutExpo",
          })

          const animateOut = () =>
              animate(document.scrollingElement, {
            scrollTop: prevPosition,
            begin: () => {
              document.body.classList.remove("is-locked")
            },
            easing: "easeOutExpo",
          })
    
          return  <div className="searchbar">
                <div className="container">
                    <p className="searchbar__heading">Find the perfect lighting solution</p>
                    <div className="searchbar__input" id={'searchContainer'}>
                        <SearchBox
                            onKeyUp={keyUp}
                            onReset={deactivate}
                            placeholder="Enter keywords"
                            resetComponent={<Reset isActive={isActive} />}
                        />
                    </div>
                </div>
                <Results   isActive={isActive} />
            </div>
         }
class Index extends Component {
      constructor(props) {
            super(props);
            this.state = { 
              count: 0,
              isActive: false,
              prevPosition: 0

             };
        }
        render() {
            return <InstantSearch searchClient={searchClient} indexName="products">
                        <Configure hitsPerPage={6} filters={`enabled:true`} />
                         <Typeahead  />
                    </InstantSearch>;
        }
}
export default Index
const root = document.querySelector(".js-typeahead")
if (root && root != null && credentials) {
  const root1 = ReactDOM.createRoot( root );
	root1.render(<Index /> )
}